/**
 * isartau — Mobiles Galerieverhalten der Produktseite
 * ---------------------------------------------------------------------------
 * ZWEI AUFGABEN, EINE QUELLE
 *
 *   1. Fortschrittsleiste (Etappe 3) — baut unter 750 px die Segment-Striche,
 *      die Dawns Zaehler ("1 / 20") und die beiden Pfeile ersetzen. Optik und
 *      Randverhalten stehen in snippets/galerie-fortschritt-styles.liquid,
 *      dort auch die Messwerte.
 *
 *   2. Slide-Meldung (08.09.2026) — schreibt die Nummer des sichtbaren Slides
 *      als data-galerie-slide an <media-gallery>. Darauf blendet
 *      snippets/versandkostenfrei-badge-styles.liquid die Overlays ueber dem
 *      Bild (Versandkosten-Badge und Marketing-Badges) ab Slide 2 aus, damit
 *      Infografiken vollstaendig lesbar bleiben.
 *
 * Beide haengen an derselben Quelle: Dawns "slideChanged". Deshalb stehen sie
 * in EINER Datei — ein zweites Skript muesste Startzustand,
 * Variantenwechsel-Neuverdrahtung und die Theme-Editor-Ereignisse noch einmal
 * nachbauen. Die Datei hiess bis zum 08.09.2026 isartau-galerie-fortschritt.js
 * und wurde mit Aufgabe 2 umbenannt; sie ist nur an einer Stelle eingebunden
 * (snippets/galerie-fortschritt.liquid).
 *
 * ZWEI QUELLEN, BEWUSST GETRENNT
 *
 *   Wie VIELE Striche  -> data-galerie-sichtbar aus Etappe 0
 *                         (assets/isartau-galerie-beobachter.js)
 *   WELCHER ist aktiv  -> Dawns SliderComponent, Ereignis "slideChanged"
 *
 * Warum nicht beides aus einer Quelle: Die Anzahl muss die von Rubik
 * variantenabhaengig ausgeblendeten Medien beruecksichtigen — das weiss nur
 * Etappe 0, und zwar erst nach ihrer Entprellung. Die aktuelle Position dagegen
 * aendert sich bei jedem Wisch und muss sofort folgen; dafuer ist Dawns
 * Slider die richtige und einzige verlaessliche Quelle. Er speist heute schon
 * den Zaehler, den wir ersetzen (assets/global.js, update()).
 *
 * ⚠️ slideChanged feuert NUR BEI AENDERUNG (assets/global.js: "if
 * (this.currentPage != previousPage)"). Der Startwert wird deshalb direkt aus
 * viewer.currentPage gelesen, nicht auf das Ereignis gewartet.
 *
 * Eingebunden ueber snippets/galerie-fortschritt.liquid, aufgerufen aus
 * sections/main-product.liquid. Keine Dawn-Datei veraendert.
 */
(function () {
  'use strict';

  /* Ab hier gilt Dawns Slider als abgeschaltet — derselbe Umschaltpunkt wie
     im Stylesheet und wie in Dawns eigener Regel
     ".slider--mobile + .slider-buttons" (assets/component-slider.css). */
  var MOBIL = '(max-width: 749px)';

  /* Bis einschliesslich diesem Wert sind alle Striche sichtbar. Darueber
     laeuft das wandernde Fenster. Am Original gemessen: 10 Bilder = alle
     sichtbar, 11 Bilder = Fenster. */
  var ALLE_BIS = 10;

  /* Groesster Abstand zum aktuellen Bild, der im Fenster noch dargestellt
     wird. 2 ergibt die gemessenen fuenf Plaetze. */
  var FENSTER = 2;

  var DEBUG = false;

  function log() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[galerie-fortschritt]');
    console.log.apply(console, args);
  }

  if (window.__isartauGalerie) return;
  window.__isartauGalerie = true;

  /* =========================================================================
   * Aufbau der Leiste
   * ======================================================================= */

  /**
   * Striche auf die gewuenschte Anzahl bringen.
   *
   * Bewusst nicht "leeren und neu aufbauen": Es werden nur so viele Knoten
   * angelegt oder entfernt, wie die Differenz ausmacht. Dadurch ueberlebt der
   * Deckkraft-Uebergang einen Neuaufbau, und mehrfaches Ausfuehren mit
   * derselben Anzahl aendert gar nichts — die Wiederholbarkeit ist damit
   * strukturell gegeben und haengt nicht an einer Zusatzpruefung.
   */
  function stricheAngleichen(leiste, anzahl) {
    var vorhanden = leiste.children.length;

    for (var i = vorhanden; i < anzahl; i++) {
      var strich = document.createElement('span');
      strich.className = 'galerie-fortschritt__strich';
      leiste.appendChild(strich);
    }
    for (var k = vorhanden; k > anzahl; k--) {
      leiste.removeChild(leiste.lastElementChild);
    }
  }

  /**
   * Abstand jedes Strichs zum aktuellen Bild als data-Attribut hinterlegen.
   * Das Stylesheet macht daraus Breite und Deckkraft.
   *
   * Ungeklammert, also ohne Nachfuehren an den Raendern — genau so verhaelt
   * sich das Original (siehe Messung im Stylesheet).
   */
  function abstaendeSetzen(leiste, aktuell) {
    var kinder = leiste.children;
    for (var i = 0; i < kinder.length; i++) {
      var abstand = Math.abs(i - aktuell);
      if (abstand <= FENSTER) {
        kinder[i].setAttribute('data-abstand', String(abstand));
      } else {
        kinder[i].removeAttribute('data-abstand');
      }
    }
  }

  /* =========================================================================
   * Zustand je Galerie
   * ======================================================================= */

  var zustaende = [];

  function abraeumen() {
    zustaende.forEach(function (z) {
      if (z.abmelden) z.abmelden();
    });
    zustaende = [];
  }

  /**
   * Aktuelle Position aus Dawns Slider lesen.
   * currentPage ist 1-basiert und zaehlt nur die tatsaechlich sichtbaren
   * Medien (assets/global.js, initPages() filtert ueber clientWidth > 0).
   * Damit passt sie zur Zaehlung aus Etappe 0.
   */
  function positionLesen(viewer, anzahl) {
    var seite = viewer && typeof viewer.currentPage === 'number' ? viewer.currentPage : 1;
    var index = seite - 1;
    if (!(index >= 0)) index = 0;
    if (index > anzahl - 1) index = anzahl - 1;
    return index;
  }

  function textSetzen(z, aktuell) {
    if (!z.text) return;
    var neu = 'Bild ' + (aktuell + 1) + ' von ' + z.anzahl;
    if (z.text.textContent === neu) return;
    z.text.textContent = neu;
  }

  function zeichnen(z, aktuell) {
    z.behaelter.setAttribute('data-modus', z.anzahl > ALLE_BIS ? 'fenster' : 'alle');
    abstaendeSetzen(z.leiste, aktuell);
    textSetzen(z, aktuell);
  }

  /**
   * Leiste fuer den gemeldeten Zustand herstellen.
   * Idempotent: derselbe Zustand fuehrt zum selben Ergebnis, ohne dass sich
   * Knoten oder Attribute aufaddieren.
   */
  function aufbauen(z, anzahl) {
    z.anzahl = anzahl;

    if (!anzahl) {
      z.behaelter.hidden = true;
      stricheAngleichen(z.leiste, 0);
      return;
    }

    /* Bei genau einem sichtbaren Medium gibt es nichts fortzuschreiten. */
    z.behaelter.hidden = anzahl < 2;

    stricheAngleichen(z.leiste, anzahl);
    zeichnen(z, positionLesen(z.viewer, anzahl));
    log('aufgebaut:', anzahl, 'Striche');
  }

  /* =========================================================================
   * Aufgabe 2: Slide-Meldung fuer die Overlays ueber dem Bild
   * ======================================================================= */

  /**
   * Schreibt die Nummer des sichtbaren Slides als data-galerie-slide an
   * <media-gallery>. Ausgewertet wird sie ausschliesslich in
   * snippets/versandkostenfrei-badge-styles.liquid, und zwar unter 750 px.
   *
   * DIE RICHTUNG IST ABSICHT: Das Attribut sagt "hier ist Slide N", es
   * schaltet nichts ab. Die CSS-Regel blendet die Overlays nur dann aus, wenn
   * das Attribut DA ist und NICHT auf 1 steht. Faellt diese Datei aus, bleibt
   * das Attribut weg — und damit alles sichtbar wie vor dem 08.09.2026. Nie
   * umdrehen: Eine Regel, die bei fehlendem Attribut ausblendet, liesse den
   * Badge bei jedem Skriptfehler ersatzlos verschwinden.
   *
   * Bewusst NICHT ueber positionLesen: Das klemmt auf die Zahl der sichtbaren
   * Medien aus Etappe 0 und arbeitet erst, wenn die gemeldet hat. Die Overlays
   * brauchen nur "erster Slide oder nicht" und sollen das ab dem ersten Wisch
   * wissen, auch ohne Etappe 0.
   *
   * Der Startwert 1 ist der sichere Fall: Solange Dawns Slider noch keine
   * currentPage kennt, gilt Slide 1 und die Overlays stehen.
   *
   * Warum das den Variantenwechsel mit abdeckt: Dawn tauscht beim Wechsel den
   * Inhalt von <media-gallery ul> aus, den Knoten <media-gallery> selbst aber
   * nicht (assets/product-info.js) — das Attribut ueberlebt also. Der Sprung
   * zum Variantenbild laeuft ueber scrollTo und loest slideChanged aus, der
   * Wert wird dadurch von selbst richtig. Bei Rubik-ausgeblendeten Medien
   * zaehlt Dawns currentPage die SICHTBAREN Folien, "Slide 1" ist damit immer
   * das tatsaechlich erste sichtbare Bild und nicht das erste im DOM.
   */
  function slideMelden(z) {
    var seite = z.viewer && typeof z.viewer.currentPage === 'number' ? z.viewer.currentPage : 1;
    if (!(seite >= 1)) seite = 1;
    z.galerie.setAttribute('data-galerie-slide', seite);
  }

  /* =========================================================================
   * Verdrahtung
   * ======================================================================= */

  function einrichten() {
    abraeumen();

    var behaelter = document.querySelectorAll('[data-galerie-fortschritt]');

    for (var i = 0; i < behaelter.length; i++) {
      var b = behaelter[i];
      var wrapper = b.closest('.product__media-wrapper');
      var galerie = wrapper ? wrapper.querySelector('media-gallery') : null;
      var viewer = galerie ? galerie.querySelector('[id^="GalleryViewer"]') : null;
      var leiste = b.querySelector('.galerie-fortschritt__leiste');
      if (!galerie || !viewer || !leiste) continue;

      var z = {
        behaelter: b,
        leiste: leiste,
        text: b.querySelector('.galerie-fortschritt__text'),
        galerie: galerie,
        viewer: viewer,
        anzahl: 0,
        abmelden: null
      };

      /* Wisch-Position. slideChanged traegt currentPage im detail mit; wir
         lesen trotzdem ueber positionLesen, damit Klemmung und Startfall
         durch dieselbe Stelle laufen. */
      var beiWechsel = function (zustand) {
        return function () {
          /* Zuerst, und ohne Bedingung: Die Overlays haengen nicht an der
             Zahl der sichtbaren Medien, die Striche schon. */
          slideMelden(zustand);
          if (!zustand.anzahl) return;
          zeichnen(zustand, positionLesen(zustand.viewer, zustand.anzahl));
        };
      }(z);
      viewer.addEventListener('slideChanged', beiWechsel);
      z.abmelden = function (v, f) {
        return function () {
          v.removeEventListener('slideChanged', f);
        };
      }(viewer, beiWechsel);

      zustaende.push(z);

      /* Startzustand der Overlays. Steht vor dem Startzustand der Leiste, weil
         er von Etappe 0 unabhaengig ist. */
      slideMelden(z);

      /* Startzustand: Hat Etappe 0 schon gemeldet, ist die Zahl bereits am
         <media-gallery> hinterlegt. Sonst bleibt die Leiste leer, bis die
         Meldung kommt — es gibt in dem Moment ohnehin noch keine belastbare
         Anzahl. */
      var schon = galerie.getAttribute('data-galerie-sichtbar');
      if (schon) aufbauen(z, parseInt(schon, 10) || 0);
      else z.behaelter.hidden = true;
    }

    log('eingerichtet:', zustaende.length, 'Leiste(n)');
  }

  function passendeGalerie(galerie) {
    for (var i = 0; i < zustaende.length; i++) {
      if (zustaende[i].galerie === galerie) return zustaende[i];
    }
    return null;
  }

  function start() {
    try {
      if (!document.querySelector('[data-galerie-fortschritt]')) return;

      einrichten();

      /* Die eine maßgebliche Quelle fuer die Anzahl. Bubbelt bis zum
         document, ueberlebt damit auch einen Austausch der Galerie. */
      document.addEventListener('isartau:galerie-eingependelt', function (ereignis) {
        try {
          var detail = ereignis.detail;
          if (!detail || !detail.galerie) return;
          var z = passendeGalerie(detail.galerie);
          if (!z) {
            /* Galerie ist neu (Produktwechsel ueber Dawns Austauschpfad) —
               komplett neu verdrahten und dann erst zeichnen. */
            einrichten();
            z = passendeGalerie(detail.galerie);
            if (!z) return;
          }
          aufbauen(z, detail.sichtbar);
        } catch (fehler) {
          log('Fehler beim Uebernehmen der Meldung', fehler);
        }
      });

      /* Theme-Editor. */
      document.addEventListener('shopify:section:load', function (ereignis) {
        if (ereignis.target && !ereignis.target.querySelector('[data-galerie-fortschritt]')) return;
        einrichten();
      });
      document.addEventListener('shopify:section:unload', function (ereignis) {
        if (ereignis.target && !ereignis.target.querySelector('[data-galerie-fortschritt]')) return;
        abraeumen();
      });

      /* Beim Wechsel ueber die Umbruchbreite neu zeichnen. Die Leiste ist ab
         750 px per CSS ausgeblendet, ihre Attribute bleiben aber stehen —
         beim Zurueckwechseln soll sofort der richtige Strich aktiv sein. */
      if (window.matchMedia) {
        var mql = window.matchMedia(MOBIL);
        var beiUmbruch = function () {
          zustaende.forEach(function (z) {
            if (z.anzahl) zeichnen(z, positionLesen(z.viewer, z.anzahl));
          });
        };
        if (mql.addEventListener) mql.addEventListener('change', beiUmbruch);
        else if (mql.addListener) mql.addListener(beiUmbruch);
      }
    } catch (fehler) {
      /* Jeder Fehler fuehrt zu "nichts tun". Faellt diese Datei aus, bleibt
         die Leiste leer und versteckt; Dawns Zaehler und Pfeile sind dann
         zwar per CSS ausgeblendet, der Slider selbst funktioniert aber
         unveraendert weiter. */
      log('Start fehlgeschlagen', fehler);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
